import { FeederContractStatusEnum } from '@bo-client/activation-management/feeder-contract/model/feeder-contract.model';
import { StatusRuleSet } from '../status-availability.model';

/** Der nächtliche Ablauf-Job läuft im Backend fest nur für diesen Mandanten. */
const EXPIRE_JOB_TENANT_ID = 'thn';

/** Einspeisevertrag: Status, die nicht jeder Mandant über einen Prozessschritt erreicht. */
export const FEEDER_CONTRACT_STATUS_RULES: StatusRuleSet = {
  blacklist: {
    [FeederContractStatusEnum.TechnicallyReviewed]: (ctx) =>
      !!ctx.config.feederContract?.showAdditionalCheckMastrDataAction,
    [FeederContractStatusEnum.ClosedWithoutFeedback]: (ctx) =>
      !!ctx.config.feederContract?.autoExpireFeederContractsNightly &&
      ctx.tenant?.id === EXPIRE_JOB_TENANT_ID,
    [FeederContractStatusEnum.Accepted]: null,
    [FeederContractStatusEnum.Cancelled]: null,
    [FeederContractStatusEnum.ToBeCreated]: null
  }
};
